import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { modalVerbsData, getDataForDifficulty } from '../courses/data/grammar/modalVerbs';

export default function ModalVerbsTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : modalVerbsData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
